<template>
	<div>
		<form-dialog
			:appendToBody="true"
			:dialogVisible.sync="dialog_visible"
			:formData="formData"
			ref="formData"
			dialogWidth="600px"
			@handleClose="close"
		>
			<dialog-title slot="title" :title="title" :subtitle="subtitle"></dialog-title>
			<dialog-footer
				slot="footer"
				:visible.sync="dialog_visible"
				@confirm="submit"
				@onclose="close"
			></dialog-footer>
		</form-dialog>
	</div>
</template>
<script>
import formDialog from '@/components/webManage/formDialog.vue';
import dialogTitle from '@/components/crm/crm-dialog-title.vue';
import Name from '@/components/crm/crm-form-name.vue';
import dialogFooter from '@/components/crm/crm-dialog-footer.vue';
import customSer from '@/client/services/customerManage/customerSer.js';
import { mapGetters } from 'vuex';
export default {
	props: {
		moveVisible: {
			type: Boolean,
		},
		data: {
			type: Object,
		},
	},
	data() {
		return {
			title: '移入公海',
			subtitle: '您正在进行客户移入公海操作',
			formData: {
				customerId: {
					displayWith: () => false,
					formType: 'sky-input',
					value: '',
				},
				name: {
					label: '公司名称：',
					formType: Name,
					value: '',
				},
				public: {
					label: '操作：',
					key: 'ids',
					formType: Name,
					value: '移入公海',
				},
			},
			dialog_visible: false,
		};
	},
	watch: {
		moveVisible: {
			handler() {
				this.dialog_visible = this.moveVisible;
				this.formData.customerId.value = this.data.customerId;
				this.formData.name.value = this.data.customerName;
			},
		},
	},
	computed: {
		...mapGetters(['chatListData', 'userInfo','allChatList']),
	},
	methods: {
		submit() {
			this.$refs.formData.validate(async valid => {
				if (valid) {
					const res = await customSer.setAsPublic({
						ids: [this.formData.customerId.value],
					});
					let item;
					if (res) {
						this.$message.success(`操作成功`);
					
						if (this.$route.name == 'allChat') {
						this.allChatList.forEach(e => {
							if (e.id == this.data.customerId) {
								e.followupName = '';
								e.followupHeadPath = '';
							}
						});
						this.$store.dispatch('setAllChatList', this.allChatList);
						item = this.allChatList.find(e => {
							if (e.id == this.data.customerId) {
								return e;
							}
						});
					     }else{
						this.chatListData.forEach(e => {
							if (e.id == this.data.customerId) {
								e.followupName = '';
								e.followupHeadPath = '';
							}
						});
						this.$store.dispatch('setChatListData', this.chatListData);
						item = this.chatListData.find(e => {
							if (e.id == this.data.customerId) {
								return e;
							}
						});
					    }
						this.close();
						this.$router.push({
							name: this.$route.name,
							query: {
								followupName: '',
								type: 2,//为2是客户
								id: item.id,
								tableId: item.tableId,
							},
						});
						this.$emit('changeName', 1);
					
					} else {
						this.close();
						this.$message.info(`操作失败`);
					}
				}
			});
		},
		close() {
			this.dialog_visible = false;
			this.$emit('update:moveVisible', false);
		},
	},
	components: {
		formDialog,
		dialogTitle,
		// Name,
		dialogFooter,
	},
};
</script>
<style lang="scss" scoped></style>
